// Custom hook for translations
import { useAppStore } from '@/app/store';
import { translations, TranslationKey } from './translations';

export const useTranslation = () => {
  const { language } = useAppStore();

  const t = (key: TranslationKey | string, fallback?: string): string => {
    const languageTranslations = translations[language as keyof typeof translations] as Record<string, string> | undefined;
    return languageTranslations?.[key as TranslationKey] || translations.fr[key as TranslationKey] || fallback || key;
  };

  return { t, language };
};